import React, { Component } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Badge from 'react-bootstrap/Badge'
import Table from 'react-bootstrap/Table'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Link } from "react-router-dom"
import { Collapse } from 'react-collapse'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPlus, faTrash, faEdit, faTimes, faSave, faUserPlus,
  faTasks, faDownload
} from '@fortawesome/free-solid-svg-icons'

import { RowEditor, getSentences } from './RowEditor'
import AuthEditor from './AuthEditor'
import DescriptionEditor from './DescriptionEditor'
import WordsEditor from './WordsEditor'
import Logs from './Logs'
import CollapseLabel from '../task/CollapseLabel'
import TempURL from '../common/TempURL'

import './TaskEditor.css'


const THEMES = ['red', 'purple', 'blue', 'green', 'yellow', 'orange', 'black']

class TaskEditor extends Component {
  constructor(props) {
    super(props);

    const url = window.location.href
    this.state = {
      baseURL: url.substring(0, url.indexOf('/dashboard/')),
      changed: {},
      validated: {},
      sentence: false,
      words: null,
      updating: false,
      shares: null,
      deleteConfirm: false,
      deleting: false,
      restoring: false,
      links: false,
    }
  }

  componentDidUpdate() {
    if (this.state.sentence || Object.values(this.state.changed).filter(p => p !== undefined).length > 0) {
      window.onbeforeunload = () => true
    } else {
      window.onbeforeunload = undefined
    }
  }

  copyState() {
    const state = Object.assign({}, this.state)
    state.changed = Object.assign({}, state.changed)
    state.validated = Object.assign({}, state.validated)
    state.words = state.words === null ? null : state.words.map(w => w.slice())
    state.shares = state.shares === null ? null : state.shares.slice()
    return state
  }

  isTargetIssue(log, rowIndex) {
    if (!log.data.data) {
      return false
    }
    const data = JSON.parse(log.data.data)
    if (!data.progress) {
      return false
    }
    if (!data.progress.detail) {
      return false
    }
    if (!data.progress.detail.selected) {
      return false
    }
    const selected = data.progress.detail.selected
    return selected.rowIndex === rowIndex
  }

  isRowIssue(log) {
    if (!log.data.data) {
      return false
    }
    const data = JSON.parse(log.data.data)
    if (!data.progress) {
      return false
    }
    return true
  }

  isWordIssue(log) {
    if (!log.data.data) {
      return false
    }
    const data = JSON.parse(log.data.data)
    if (!data.word) {
      return false
    }
    return true
  }

  titleChange(e) {
    const state = this.copyState()
    const newvalue = e.target.value
    state.changed.title = newvalue === this.props.taskdata.data.title ? undefined : newvalue
    this.setState(state)
  }

  descriptionChange(newvalue) {
    const state = this.copyState()
    state.changed.description = newvalue === this.props.taskdata.data.description ? undefined : newvalue
    this.setState(state)
  }

  requireAuthChange(require_auth, whitelist_auth) {
    const state = this.copyState()
    state.changed.require_auth = require_auth === this.props.taskdata.data.require_auth ? undefined : require_auth
    state.changed.whitelist_auth = whitelist_auth === this.props.taskdata.data.whitelist_auth ? undefined : whitelist_auth
    this.setState(state)
  }

  requireAuthValidate(valid) {
    const state = this.copyState()
    state.validated.require_auth = valid
    this.setState(state)
  }

  importableChange(e) {
    const state = this.copyState()
    const newvalue = e.target.value === 'true'
    state.changed.importable = newvalue === this.props.taskdata.data.importable ? undefined : newvalue
    this.setState(state)
  }

  evaluationChange(e) {
    const state = this.copyState()
    const newvalue = e.target.value
    state.changed.evaluation = newvalue === this.props.taskdata.data.evaluation ? undefined : newvalue
    this.setState(state)
  }

  disableWordClickChange(e) {
    const state = this.copyState()
    const newvalue = e.target.value === 'true'
    const oldvalue = this.props.taskdata.data.disable_word_click ? true : false
    state.changed.disable_word_click = newvalue === oldvalue ? undefined : newvalue
    this.setState(state)
  }

  themeChange(e) {
    const state = this.copyState()
    const newvalue = e.target.value
    state.changed.theme = newvalue === this.props.taskdata.data.theme ? undefined : newvalue
    this.setState(state)
  }

  choiceCountsChange(e) {
    const state = this.copyState()
    if (this.props.taskdata.data.choice_counts !== e.target.value && this.props.taskdata.data.mode === 'classic') {
      const r = window.confirm('クラシックモードの場合、空欄数を変更すると空欄定義も再生成されます。よろしいですか？')
      if (!r) {
        return
      }
      const data = JSON.parse(state.changed.data || this.props.taskdata.data.data)
      const newData = data.map(d => d.slice())
      const choiceCounts = parseInt(e.target.value)
      data.forEach((row, rowIndex) => {
        getSentences(row, rowIndex).forEach(sentence => {
          if (!sentence.cells.some(c => c.includes('|'))) {
            return
          }
          let cellIndex = 0
          sentence.cells.forEach((cell, actualIndex) => {
            const cellv = cell.split('|')[0]
            if (!cellv.match(/^[A-Za-z]+$/)) {
              return
            }
            cellIndex ++
            const newValue = cellIndex % choiceCounts === 0 ? `${cellv}|*` : cellv
            newData[sentence.rowIndex][sentence.beginIndex + actualIndex] = newValue
          })
        })
      })
      state.changed.data = JSON.stringify(newData)
    }
    const newvalue = e.target.value
    state.changed.choice_counts = newvalue === this.props.taskdata.data.choice_counts ? undefined : newvalue
    this.setState(state)
  }

  saveChanges() {
    if (Object.values(this.state.changed).filter(p => p !== undefined).length === 0 || !this.props.onSaveChanges) {
      this.setState({
        changed: {},
        validated: {},
      })
      return
    }
    this.setState({
      updating: true,
    }, () => {
      this.props.onSaveChanges(this.state.changed, () => {
        this.setState({
          changed: {},
          validated: {},
          updating: false,
        }, () => {
          window.location.reload()
        })
      })
    })
  }

  deleteTask() {
    this.setState({
      deleting: true,
    }, () => {
      this.props.onDelete(() => {
        window.location.href = '/dashboard/'
      })
    })
  }

  restoreTask() {
    this.setState({
      restoring: true,
    }, () => {
      this.props.onRestore(() => {
        window.location.reload()
      })
    })
  }

  rowChange(rowIndex, row) {
    const state = this.copyState()
    state.changed.data = state.changed.data || this.props.taskdata.data.data
    const taskData = JSON.parse(state.changed.data)
    taskData[rowIndex] = row
    const taskDataJson = JSON.stringify(taskData)
    state.changed.data = taskDataJson === this.props.taskdata.data.data ? undefined : taskDataJson
    this.setState(state)
  }

  addRow(rowIndex, text, callback) {
    console.log('ADD', rowIndex, text)
    if (!this.props.onGenerateRow) {
      return
    }
    this.props.onGenerateRow(this.props.taskdata.data, text, false, (row, chunksRow) => {
      if (!row || !chunksRow) {
        console.error('ERROR')
        return
      }
      const state = this.copyState()
      state.changed.data = state.changed.data || this.props.taskdata.data.data
      state.changed.chunksData = state.changed.chunksData || this.props.taskdata.data.chunksData
      const taskData = JSON.parse(state.changed.data)
      const taskChunksData = JSON.parse(state.changed.chunksData)

      taskData.splice(rowIndex + 1, 0, row)
      taskChunksData.splice(rowIndex + 1, 0, chunksRow)

      const taskDataJson = JSON.stringify(taskData)
      const taskChunksDataJson = JSON.stringify(taskChunksData)
      state.changed.data = taskDataJson === this.props.taskdata.data.data ? undefined : taskDataJson
      state.changed.chunksData = taskChunksDataJson === this.props.taskdata.data.chunksData ? undefined : taskChunksDataJson
      this.setState(state, callback)
    })
  }

  editRow(rowIndex, text, callback) {
    console.log('EDIT', rowIndex, text)
    if (this.props.taskdata.data.image && text.trim() === '') {
      // Empty data
      this.updateRow(rowIndex, [], [], callback)
      return
    }
    if (!this.props.onGenerateRow) {
      return
    }
    let force = false
    if (this.props.taskdata.data.image && rowIndex > 0) {
      const taskData = JSON.parse(this.props.taskdata.data.data)
      const prev = taskData[rowIndex - 1][0].match(/^!([^#]+)(#.+)?$/)
      const target = taskData[rowIndex][0].match(/^!([^#]+)(#.+)?$/)
      if (prev && target && prev[1] === target[1]) {
        force = true
      }
    }
    this.props.onGenerateRow(this.props.taskdata.data, text, force, (row, chunksRow) => {
      if (!row || !chunksRow) {
        console.error('ERROR')
        return
      }
      this.updateRow(rowIndex, row, chunksRow, callback)
    })
  }

  updateRow(rowIndex, row, chunksRow, callback) {
    const state = this.copyState()
    state.changed.data = state.changed.data || this.props.taskdata.data.data
    state.changed.chunksData = state.changed.chunksData || this.props.taskdata.data.chunksData
    const taskData = JSON.parse(state.changed.data)
    const taskChunksData = JSON.parse(state.changed.chunksData)

    if (this.props.taskdata.data.image) {
      taskData.splice(
        rowIndex,
        1,
        taskData[rowIndex].slice(0, 1).concat(row)
      )
      taskChunksData.splice(
        rowIndex,
        1,
        taskChunksData[rowIndex]
          .slice(0, 1)
          .concat(chunksRow.map(indices => indices.map(index => index.map(i => i + 1))))
      )
    } else {
      taskData.splice(rowIndex, 1, row)
      taskChunksData.splice(rowIndex, 1, chunksRow)
    }

    const taskDataJson = JSON.stringify(taskData)
    const taskChunksDataJson = JSON.stringify(taskChunksData)
    state.changed.data = taskDataJson === this.props.taskdata.data.data ? undefined : taskDataJson
    state.changed.chunksData = taskChunksDataJson === this.props.taskdata.data.chunksData ? undefined : taskChunksDataJson
    this.setState(state, callback)
  }

  deleteRow(rowIndex) {
    console.log('DELETE', rowIndex)
    const state = this.copyState()
    state.changed.data = state.changed.data || this.props.taskdata.data.data
    state.changed.chunksData = state.changed.chunksData || this.props.taskdata.data.chunksData
    const taskData = JSON.parse(state.changed.data)
    const taskChunksData = JSON.parse(state.changed.chunksData)

    taskData.splice(rowIndex, 1)
    taskChunksData.splice(rowIndex, 1)

    const taskDataJson = JSON.stringify(taskData)
    const taskChunksDataJson = JSON.stringify(taskChunksData)
    state.changed.data = taskDataJson === this.props.taskdata.data.data ? undefined : taskDataJson
    state.changed.chunksData = taskChunksDataJson === this.props.taskdata.data.chunksData ? undefined : taskChunksDataJson
    this.setState(state)
  }

  moveRow(rowIndex, target) {
    console.log('MOVE', rowIndex, target)
    const state = this.copyState()
    state.changed.data = state.changed.data || this.props.taskdata.data.data
    state.changed.chunksData = state.changed.chunksData || this.props.taskdata.data.chunksData
    const taskData = JSON.parse(state.changed.data)
    const taskChunksData = JSON.parse(state.changed.chunksData)

    const targetData = taskData.splice(rowIndex, 1)
    taskData.splice(rowIndex + target, 0, targetData[0])
    const targetChunksData = taskChunksData.splice(rowIndex, 1)
    taskChunksData.splice(rowIndex + target, 0, targetChunksData[0])

    const taskDataJson = JSON.stringify(taskData)
    const taskChunksDataJson = JSON.stringify(taskChunksData)
    state.changed.data = taskDataJson === this.props.taskdata.data.data ? undefined : taskDataJson
    state.changed.chunksData = taskChunksDataJson === this.props.taskdata.data.chunksData ? undefined : taskChunksDataJson
    this.setState(state)
  }

  forSamePage(row1, row2) {
    if (row1.length === 0 || row2.length === 0) {
      return true
    }
    const m1 = row1[0].match(/^!([^#]+)(#.+)?$/)
    const m2 = row2[0].match(/^!([^#]+)(#.+)?$/)
    if (!m1 && !m2) {
      return true
    }
    if (!m1 || !m2) {
      return false
    }
    return m1[1] === m2[1]
  }

  startShare() {
    const state = this.copyState()
    state.shares = (this.props.taskdata.data.shares || ['']).slice()
    this.setState(state)
  }

  closeShare(cancel) {
    if (cancel || !this.props.onSharesChanges) {
      this.setState({
        shares: null,
      })
      return
    }
    this.setState({
      updating: true,
    }, () => {
      this.props.onSharesChanges(this.state.shares, () => {
        this.setState({
          shares: null,
          updating: false,
        })
      })
    })
  }

  closeDeleteConfirm() {
    this.setState({
      deleteConfirm: false,
    })
  }

  addShare() {
    const state = this.copyState()
    state.shares.push('')
    this.setState(state)
  }

  removeShare(userIndex) {
    const state = this.copyState()
    state.shares.splice(userIndex, 1)
    this.setState(state)
  }

  shareChange(userIndex, event) {
    const state = this.copyState()
    state.shares.splice(userIndex, 1, event.target.value)
    this.setState(state)
  }

  isInvalidUser(user) {
    return !user.match(/^.+@.+$/)
  }

  toggleSentence() {
    this.setState({
      sentence: !this.state.sentence
    })
  }

  toggleWords() {
    if (this.state.words !== null) {
      const state = this.copyState()
      const taskDataJson = JSON.stringify(this.state.words)
      state.changed.wordsData = taskDataJson === this.props.taskdata.data.wordsData ? undefined : taskDataJson
      state.words = null
      this.setState(state)
      return
    }
    this.setState({
      words: JSON.parse(this.state.changed.wordsData || this.props.taskdata.data.wordsData)
    })
  }

  wordsChange(words) {
    const state = this.copyState()
    state.words = words.map(w => w.map(v => v))
    this.setState(state)
  }

  createLogURL(callback) {
    if (!this.props.onCreateLogURL) {
      return
    }
    this.props.onCreateLogURL((path, expiration) => {
      if (!callback) {
        return;
      }
      callback(path, expiration);
    })
  }

  copyLogURL() {
    const copyText = this.logUrlRef.current
    copyText.select()
    copyText.setSelectionRange(0, 99999) /*For mobile devices*/
    document.execCommand("copy")
  }

  downloadStats() {
    if (!this.props.onDownloadStats) {
      return
    }
    this.props.onDownloadStats()
  }

  renderModals() {
    const cellText = this.state.cell ? this.state.cell.text : ''
    let selectables = cellText.split('|').slice(1)
    if (selectables.length === 1 && selectables[0] === '*') {
      selectables = []
    }
    const shareEditor = <Modal
      data-test-share-modal-detail
      show={this.state.shares !== null}
      animation={true}
      onHide={e => this.closeShare()}>
      <Modal.Header closeButton>
        <Modal.Title>共有設定</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Googleアカウントにより共有相手を指定することができます。
        </p>
        {(this.state.shares || []).map((user, userIndex) =>
          <Form.Group key={`share-${userIndex}`}>
            <Form.Label>共有先</Form.Label>
            <Form.Control
              placeholder='Googleアカウント'
              defaultValue={user}
              onChange={e => this.shareChange(userIndex, e)} />
            <Button
              variant='light'
              data-test-share-selectable-remove
              onClick={e => this.removeShare(userIndex, e)}>
              <FontAwesomeIcon icon={faTrash} />
              削除
            </Button>
          </Form.Group>)}
        <Button
          variant='light'
          disabled={(this.state.shares || []).some(share => share.length === 0)}
          data-test-share-selectable-add
          onClick={e => this.addShare(e)}>
          <FontAwesomeIcon icon={faPlus} />
          追加
        </Button>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='light'
          data-test-share-detail-cancel
          onClick={e => this.closeShare(true)}>
          キャンセル
        </Button>
        <Button
          variant='light'
          data-test-share-detail-finish
          disabled={this.state.updating || (this.state.shares || []).some(share => this.isInvalidUser(share))}
          onClick={e => this.closeShare(false)}>
          {this.state.updating ? '保存しています...' : '保存して閉じる'}
        </Button>
      </Modal.Footer>
    </Modal>
    const deleteDialog = <Modal
      data-test-delete-modal-confirm
      show={this.state.deleteConfirm}
      animation={true}
      onHide={e => this.closeDeleteConfirm()}>
      <Modal.Header closeButton>
        <Modal.Title>削除確認</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          この問題を削除してよろしいですか？
          削除した問題は <Link to='/dashboard/trash'>ゴミ箱</Link> から戻すことができます。
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='light'
          data-test-delete-confirm-cancel
          onClick={e => this.closeDeleteConfirm(true)}>
          キャンセル
        </Button>
        <Button
          variant='danger'
          data-test-delete-confirm-ok
          disabled={this.state.deleting}
          onClick={e => this.deleteTask(false)}>
          {this.state.deleting ? '削除しています...' : '削除'}
        </Button>
      </Modal.Footer>
    </Modal>
    return <div>
      {shareEditor}
      {deleteDialog}
    </div>
  }

  equalsLink(link1, link2) {
    if (link1 === undefined && link2 === undefined) {
      return true
    }
    if (link1 === undefined || link2 === undefined) {
      if ((link1 && link1.task) || (link2 && link2.task)) {
        return false
      }
      if (link1 && link1.task === undefined && (link1.title || link1.url)) {
        return false
      }
      if (link2 && link2.task === undefined && (link2.title || link2.url)) {
        return false
      }
      return true
    }
    return JSON.stringify(link1) === JSON.stringify(link2)
  }

  equalsLinks(links1, links2) {
    const linkTypes = ['index', 'previous', 'next']
    const links1obj = JSON.parse(links1 || '{}')
    const links2obj = JSON.parse(links2 || '{}')
    return linkTypes.every((linkType) => this.equalsLink(links1obj[linkType], links2obj[linkType]))
  }

  linksTaskChange(ev, linkType) {
    const state = this.copyState()
    state.changed.links = state.changed.links || this.props.taskdata.data.links || '{}'
    const links = JSON.parse(state.changed.links)
    const targetTasks = (this.props.tasks || []).filter((task) => task.id === ev.target.value)
    const newLink = {
      task: ev.target.value === 'none' ? undefined : ev.target.value,
      title: targetTasks.length === 0 ? '' : (targetTasks[0].data.title || ''),
      url: targetTasks.length === 0 ? '' : `${this.state.baseURL}/?task_id=${targetTasks[0].data.taskId}&v2=1`,
    }
    links[linkType] = newLink
    const newLinks = JSON.stringify(links)
    state.changed.links = this.equalsLinks(newLinks, this.props.taskdata.data.links) ? undefined : newLinks
    this.setState(state)
  }

  linksPropertyChange(ev, propName, linkType) {
    const state = this.copyState()
    state.changed.links = state.changed.links || this.props.taskdata.data.links || '{}'
    const links = JSON.parse(state.changed.links)
    const newLink = links[linkType] || {}
    newLink[propName] = ev.target.value
    links[linkType] = (newLink.task === undefined && newLink.title === '' && newLink.url === '') ? undefined : newLink
    const newLinks = JSON.stringify(links)
    state.changed.links = this.equalsLinks(newLinks, this.props.taskdata.data.links) ? undefined : newLinks
    this.setState(state)
  }

  renderLinksEditor() {
    const links = JSON.parse(this.state.changed.links || this.props.taskdata.data.links || '{}')
    const linkTypes = ['index', 'previous', 'next']
    const linkTypeFaces = ['一覧', '前のコンテンツ', '次のコンテンツ']
    return <div className='LinksEditor'>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>タイプ</th>
            <th>タイトル</th>
            <th>URL</th>
          </tr>
        </thead>
        <tbody>
          {linkTypes.map((linkType, linkTypeIndex) => <tr key={linkType}>
              <td>{linkTypeFaces[linkTypeIndex]}</td>
              <td>
                {this.props.readonly && links[linkType] && links[linkType].title}
                {!this.props.readonly && <Row>
                    <Col>
                      <Form.Control
                        data-test-link-tasks
                        as='select'
                        onChange={ev => this.linksTaskChange(ev, linkType)}
                        value={(links[linkType] && links[linkType].task) || 'none'}>
                        <option value='none'>手動入力</option>
                        {(this.props.tasks || []).map((task) =>
                          <option key={task.id} value={task.id}>
                            {task.data.title}
                          </option>)}
                      </Form.Control>
                    </Col>
                    <Col>
                      {(links[linkType] && links[linkType].task !== undefined) ?
                        links[linkType].title :
                        <Form.Control
                          data-test-task-title
                          placeholder='タイトル'
                          defaultValue={links[linkType] ? (links[linkType].title || '') : ''}
                          onChange={e => this.linksPropertyChange(e, 'title', linkType)} />}
                    </Col>
                  </Row>}
              </td>
              <td>
                {this.props.readonly && links[linkType] && <a
                    href={links[linkType].url}
                    target='_blank'
                    rel='noopener noreferrer'
                  >{links[linkType].url}</a>}
                {!this.props.readonly && ((links[linkType] && links[linkType].task !== undefined) ?
                  <a
                    href={links[linkType].url}
                    target='_blank'
                    rel='noopener noreferrer'
                  >{links[linkType].url}</a> :
                  <Form.Control
                    data-test-task-url
                    placeholder='URL'
                    defaultValue={links[linkType] ? (links[linkType].url || '') : ''}
                    onChange={e => this.linksPropertyChange(e, 'url', linkType)} />)}
              </td>
            </tr>)}
        </tbody>
      </Table>
    </div>
  }

  render() {
    const currentRows = JSON.parse(this.state.changed.data || this.props.taskdata.data.data)

    return <div className='TaskEditor'>
      <h2>Cloze Test情報</h2>
      {this.props.taskdata.data.trash && <div>
          <Button
            data-test-delete-undo
            onClick={e => this.restoreTask(e)}
            disabled={this.state.restoring}
            variant='success'>
            {this.state.restoring ? '元に戻しています...' : 'ゴミ箱から戻す'}
          </Button>
        </div>}
      <p>
        Cloze Testの情報は以下の通りです。
        学習者にテストや単語クイズを実施させる場合は、それぞれのURLをコピー＆ペーストして配布してください。
      </p>
      <ul className='ResourceURL'>
        {[
          {displayName: 'テスト', type: 'v2'},
          {displayName: '単語クイズ', type: 'quiz'},
        ].map(t =>
          <li key={t.type}>{t.displayName}: <a
            href={`${this.state.baseURL}?task_id=${this.props.taskdata.data.taskId}&${t.type}=1`}
            target='_blank'
            rel='noopener noreferrer'
          >
            {`${this.state.baseURL}?task_id=${this.props.taskdata.data.taskId}&${t.type}=1`}
          </a></li>
        )}
      </ul>
      {!this.props.readonly && <p>
          問題の内容を変更する場合は、以下の項目を変更して [変更を反映] ボタンを押してください。
          [変更を反映] せずにブラウザの戻るボタンで戻ったり、再読み込みすると変更内容は破棄されます。
        </p>}
      <ul>
        {this.props.readonly && <li>共有者: {this.props.taskdata.data.user_email}</li>}
        <li>タイトル:
          {this.props.readonly ? this.props.taskdata.data.title : <Form.Control
            data-test-task-title
            placeholder='タイトル'
            defaultValue={this.props.taskdata.data.title}
            onChange={e => this.titleChange(e)} />}
        </li>
        <li>説明:
          <DescriptionEditor
            readonly={this.props.readonly}
            description={this.state.changed.description !== undefined ? this.state.changed.description : this.props.taskdata.data.description}
            onChange={(value) => this.descriptionChange(value)}
          />
        </li>
        <li>認証:
          <AuthEditor
            userEmail={this.props.userEmail}
            readonly={this.props.readonly}
            require_auth={this.state.changed.require_auth !== undefined ? this.state.changed.require_auth : this.props.taskdata.data.require_auth}
            whitelist_auth={this.state.changed.whitelist_auth !== undefined ? this.state.changed.whitelist_auth : this.props.taskdata.data.whitelist_auth}
            base_require_auth={this.props.taskdata.data.base_require_auth}
            base_whitelist_auth={this.props.taskdata.data.base_whitelist_auth}
            onChange={(require_auth, whitelist_auth) => this.requireAuthChange(require_auth, whitelist_auth)}
            onValidate={valid => this.requireAuthValidate(valid)}
          />
        </li>
        <li>空欄数:
          {this.props.readonly ? `${parseInt(this.props.taskdata.data.choice_counts)}語ずつ` : <Form.Control
            as='select'
            onChange={ev => this.choiceCountsChange(ev)}
            value={this.state.changed.choice_counts || this.props.taskdata.data.choice_counts}>
            {[...Array(6).keys()].map(cc => <option key={cc} value={cc + 5}>
              {cc + 5}語ずつ</option>)}
          </Form.Control>}
        </li>
        <li>採点方式:
          {this.props.readonly ? (this.props.taskdata.data.evaluation === 'smart' ? '自由記述スマート採点(開発中)' : '完全一致') : <Form.Control
            data-test-task-evaluation
            as='select'
            onChange={ev => this.evaluationChange(ev)}
            value={(this.state.changed.evaluation !== undefined ? this.state.changed.evaluation : this.props.taskdata.data.evaluation) || 'smart'}>
            <option value='exact'>完全一致</option>
            <option value='smart'>自由記述スマート採点(開発中)</option>
          </Form.Control>}
        </li>
        <li>単語ヒント(辞書)機能:
          {this.props.readonly ? (this.props.taskdata.data.disable_word_click ? '無効' : '有効') : <Form.Control
            data-test-task-disable-word-click
            as='select'
            onChange={ev => this.disableWordClickChange(ev)}
            value={(this.state.changed.disable_word_click !== undefined ? this.state.changed.disable_word_click : this.props.taskdata.data.disable_word_click) ? 'true' : 'false'}>
            <option value='false'>有効</option>
            <option value='true'>無効</option>
          </Form.Control>}
        </li>
        <li>学習者のアカウントへのコピー:
          {this.props.readonly ? (this.props.taskdata.data.importable ? '許可する' : '許可しない') : <Form.Control
            data-test-task-importable
            as='select'
            onChange={ev => this.importableChange(ev)}
            value={(this.state.changed.importable !== undefined ? this.state.changed.importable : this.props.taskdata.data.importable) ? 'true' : 'false'}>
            <option value='true'>許可する</option>
            <option value='false'>許可しない</option>
          </Form.Control>}
        </li>
        <li>テーマ色:
          {this.props.readonly ? (this.props.taskdata.data.theme || 'default') : <Form.Control
            data-test-task-theme
            as='select'
            onChange={ev => this.themeChange(ev)}
            value={(this.state.changed.theme !== undefined ? this.state.changed.theme : this.props.taskdata.data.theme) || 'default'}>
            <option value='default'>標準</option>
            {THEMES.map(theme => <option key={theme} value={theme}>
              {theme}
            </option>)}
          </Form.Control>}
        </li>
      </ul>
      <CollapseLabel
        title='リンク'
        isOpened={this.state.links}
        onClick={(prevOpened) => this.setState({ links: !prevOpened })}
      />
      <Collapse isOpened={this.state.links}>
        {this.renderLinksEditor()}
      </Collapse>
      {!this.props.readonly &&
        <div>
          <p>
            {this.state.sentence && '問題は単語をタップして空欄化できます。([文章の空欄編集を終了]し、[変更を反映]するまで問題には反映されません。)'}
            {this.state.words && '英単語クイズの内容を編集してください。([単語クイズの編集を終了]し、[変更を反映]するまで問題には反映されません。)'}
          </p>
          {this.state.sentence && <div>
            {currentRows.map((row, rowIndex) =>
              <div key={rowIndex} className='RowEditor'>
                <RowEditor
                  onChange={(rowIndex, data) => this.rowChange(rowIndex, data)}
                  onAdd={(rowIndex, text, callback) => this.addRow(rowIndex, text, callback)}
                  onEdit={(rowIndex, text, callback) => this.editRow(rowIndex, text, callback)}
                  onDelete={(rowIndex) => this.deleteRow(rowIndex)}
                  row={row}
                  rowIndex={rowIndex}
                  issueLogs={(this.props.issueLogs || []).filter(log => this.isTargetIssue(log, rowIndex))}
                  image={this.props.taskdata.data.image}
                  onResolve={this.props.onResolve}
                  hasToNext={rowIndex + 1 < currentRows.length && this.forSamePage(row, currentRows[rowIndex + 1])}
                  hasToPrev={rowIndex > 0 && this.forSamePage(row, currentRows[rowIndex - 1])}
                  onToNext={(rowIndex) => this.moveRow(rowIndex, 1)}
                  onToPrev={(rowIndex) => this.moveRow(rowIndex, -1)}
                />
              </div>)}
          </div>}
          <div>
            <Button
              data-test-task-sentence
              onClick={e => this.toggleSentence(e)}
              disabled={this.state.words}
              variant='light'>
              <FontAwesomeIcon icon={!this.state.sentence ? faEdit : faTimes} />
              {!this.state.sentence ? '文章の空欄編集を開始 ' : '文章の空欄編集を終了'}
              {!this.state.sentence && (this.props.issueLogs || []).filter(l => this.isRowIssue(l) && !l.data.resolved).length > 0 && <span>
                <Badge variant='danger'>{this.props.issueLogs.filter(l => this.isRowIssue(l) && !l.data.resolved).length}</Badge>{' '}
              </span>}
            </Button>
          </div>
          {this.state.words && <WordsEditor
            words={this.state.words}
            issueLogs={(this.props.issueLogs || []).filter(l => this.isWordIssue(l))}
            onChange={(words) => this.wordsChange(words)}
            onResolve={this.props.onWordResolve}
          />}
          <div>
            <Button
              data-test-task-words
              onClick={e => this.toggleWords(e)}
              disabled={this.state.sentence}
              variant='light'>
              <FontAwesomeIcon icon={!this.state.words ? faEdit : faTimes} />
              {!this.state.words ? '単語クイズの編集を開始' : '単語クイズの編集を終了'}
              {!this.state.words && (this.props.issueLogs || []).filter(l => this.isWordIssue(l) && !l.data.resolved).length > 0 && <span>
                <Badge variant='danger'>{this.props.issueLogs.filter(l => this.isWordIssue(l) && !l.data.resolved).length}</Badge>{' '}
              </span>}
            </Button>
          </div>
          <div className='SaveChanges'>
            <Button
              data-test-task-save
              onClick={e => this.saveChanges(e)}
              disabled={this.state.sentence || this.state.words || this.state.updating ||
                Object.values(this.state.changed).filter(p => p !== undefined).length === 0 ||
                Object.values(this.state.validated).some(v => !v)}
              variant='success'>
              <FontAwesomeIcon icon={faSave} />
              {Object.values(this.state.validated).some(v => !v) ? '編集内容にエラーがあります' : (this.state.sentence || this.state.words ? '問題・単語編集中は変更を反映できません' : (this.state.updating ? '変更を反映中です...' : '変更を反映'))}
            </Button>
          </div>
        </div>}
      {!this.props.readonly && this.props.taskdata.data.image && !this.props.taskdata.data.base && <div>
          <h2>画像情報の編集</h2>
          <div className='ImageEditorLink'>
            <Link to={`/dashboard/${this.props.taskid}/image`}>
              <Button
                data-test-cloze-image
                variant='light'>
                <FontAwesomeIcon icon={faEdit} />
                画像中の文字配置を編集
              </Button>
            </Link>
          </div>
        </div>}
      {!this.props.readonly && <div>
          <h2>問題の共有</h2>
          <p>
            問題を共有すると、共有相手は問題の定義や現在のログを参照することが可能になります。
          </p>
          <Button
            data-test-cloze-share
            onClick={e => this.startShare()}
            variant='light'>
            <FontAwesomeIcon icon={faUserPlus} />
            共有設定 ({(this.props.taskdata.data.shares || []).length === 0 ? '共有なし' : `${this.props.taskdata.data.shares.length}名と共有中`})
          </Button>
        </div>}
      {!this.props.readonly && <div className='DeletePanel'>
          <h2>問題の削除</h2>
          <p>
            削除した問題は <Link to='/dashboard/trash'>ゴミ箱</Link> から戻すことができます。
          </p>
          <Button
            data-test-cloze-delete
            onClick={e => this.setState({
              deleteConfirm: true,
            })}
            variant='danger'>
            <FontAwesomeIcon icon={faTrash} />
            この問題を削除
          </Button>
        </div>}
      <h2>回答ログ</h2>
      <div className='LogToolButtons'>
        <Button
          data-test-download-stats
          onClick={ev => this.downloadStats()}
          variant='light'>
          <FontAwesomeIcon icon={faDownload} />
          実施状況CSVをダウンロード
        </Button>
        <Link to={`/dashboard/${this.props.taskid}/stats`}>
          <Button
            data-test-cloze-stats
            variant='light'>
            <FontAwesomeIcon icon={faTasks} />
            回答状況・点数を確認
          </Button>
        </Link>
        <TempURL
          baseURL={this.state.baseURL}
          onCreateURL={(callback) => this.createLogURL(callback)}
          name='ログ取得URL'
          notice='(5分限定)'
        />
      </div>
      <Logs logs={this.props.logs} maxlogs={this.props.maxlogs} />
      {this.renderModals()}
    </div>
  }
}

export default TaskEditor;
